export const SET_BUILDINGS = 'SET_BUILDINGS';

export function setBuildings(buildings) {
  return {
    type: SET_BUILDINGS,
    buildings,
  };
}
